import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { RefreshIcon } from 'assets/materialIcons/materialIcons';
import { connect } from 'react-redux';
import { orderRetryRequest } from 'store/actions/orderActions';

const RetryButton = (props) => {
    const {
        id,
        isLoading,
        retry,
        translate,
    } = props;

    return <Button
        icon={ <RefreshIcon color={ isLoading ? theme.palette.doveGray : theme.palette.darkOrange } /> }
        onClick={ () => {
            return retry(id);
        } }
        title={ translate('actions.retry') }
    />;
};

RetryButton.propTypes = {
    id: PropTypes.number.isRequired,
    isLoading: PropTypes.number,
    retry: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    return {
        isLoading: state.loading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        retry: (id) => {
            return dispatch(orderRetryRequest({
                id: id,
            }));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(translate(RetryButton));



// WEBPACK FOOTER //
// ./src/components/button/RetryButton.js